import { TabProps } from '@libs-uuif/shared/sw-tab-layout';
import { nsmWidgets } from '../widgets-configuration/nsm-widgets';
import { wcmWidgets } from '../widgets-configuration/wcm-widgets';
import { ccWidgets } from '../widgets-configuration/cc-widgets';
import { casWidgets } from '../widgets-configuration/cas-widgets';
import { cloudEdgeWidgets } from '../widgets-configuration/cloud-edge-widgets';
import { switchesWidgets } from '../widgets-configuration/switch-widgets';

type widgetDataGroupType = {
  firewall: string;
  wireless: string;
  'capture client': string;
  cas: string;
  switches: string;
  cloud_edge: string;
};

// for insert widget modal side tabs
export const insertWidgetTabsProps: TabProps[] = [
  { tabId: 'firewall', label: 'Firewall' },
  {
    tabId: 'capture client',
    label: 'Capture Client',
    disabled: false,
  },
  { tabId: 'wireless', label: 'Wireless', disabled: false },
  { tabId: 'switches', label: 'Switches', disabled: false },
];

// to get insert widget modal selected tab data group
export const widgetDataGroup: widgetDataGroupType = {
  'capture client': 'capture client',
  firewall: 'firewall',
  wireless: 'wireless',
  switches: 'switches',
  cas: 'cas',
  cloud_edge: 'cloud_edge',
};

// to get the selected tab widgets
export const widgetProduct: any = {
  firewall: nsmWidgets,
  wireless: wcmWidgets,
  'capture client': ccWidgets,
  cas: casWidgets,
  cloud_edge: cloudEdgeWidgets,
  switches: switchesWidgets,
};
